var map = {
	"./algeria.png": "d075",
	"./america.png": "09d8",
	"./angola.png": "7080",
	"./argentina.png": "d1fa",
	"./australia.png": "f6b1",
	"./austria.png": "69e4",
	"./belgium.png": "ca81",
	"./brasil.png": "36b0",
	"./canada.png": "e7dd",
	"./chile.png": "ad89",
	"./china.png": "7224",
	"./colombia.png": "0027",
	"./congo.png": "09c2",
	"./denmark.png": "754c",
	"./ecuador.png": "2f08",
	"./egypt.png": "4474",
	"./ethiopia.png": "e416",
	"./fiji.png": "62a3",
	"./finland.png": "d49d",
	"./france.png": "6a5d",
	"./germany.png": "1b54",
	"./india.png": "ca71",
	"./indonesia.png": "c551",
	"./iran.png": "8b88",
	"./ireland.png": "3941",
	"./israel.png": "6d84",
	"./italy.png": "83f4",
	"./japan.png": "c9b9",
	"./kenya.png": "5a4c",
	"./korea.png": "ec62",
	"./malaysia.png": "84b3",
	"./mexico.png": "ea66",
	"./nederland.png": "9276",
	"./newzealand.png": "3685",
	"./norway.png": "a2a2",
	"./pakistan.png": "79fe",
	"./papuanewguinea.png": "d3ac",
	"./paraguay.png": "62a05",
	"./philippines.png": "5a97",
	"./poland.png": "e70d",
	"./russia.png": "b4f8",
	"./saudiarabia.png": "8cda",
	"./singapore.png": "1e2d",
	"./southafrica.png": "ed3b",
	"./spain.png": "e5d8",
	"./sweden.png": "1791",
	"./switzerland.png": "d6339",
	"./thailand.png": "a077",
	"./turkey.png": "3956",
	"./uk.png": "16f7",
	"./venezuela.png": "f536",
	"./zimbabwe.png": "fcf9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c002";